export default "__VITE_PUBLIC_ASSET__6efca8a2__"